<template>
  <div class="couponadd" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据提交中..." element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <ul class="lsls first">
      <li>
        <h2>{{detail.title}}</h2>
      </li>
      <li>
        <span><i style="color:#f00">*</i> 产品名称</span>
        <input type="text" v-model="title" placeholder="请填写产品名称"/>
      </li>
      <li>
        <span><i style="color:#f00">*</i> 产品原价</span>
        <input type="number" v-model="price" placeholder="请输入产品原价"/>
        <font>元</font>
      </li>
      <li>
        <span><i style="color:#f00">*</i> 优惠价</span>
        <input type="number" v-model="rate" placeholder="请输入优惠价"/>
        <font>元</font>
      </li>
      <li>
        <span><i style="color:#f00">*</i> 产品简介</span>
        <input type="text" v-model="jianj" placeholder="请输入产品简介"/>
      </li>
      <li>
        <span><i style="color:#f00">*</i> 所属分类</span>
        <input @click="chooseCate" type="text" v-model="msg" value="" readonly="readonly" placeholder="请选择所属分类"/>
        <img @click="chooseCate" class="icon" src="~assets/images/icon5.png" />
      </li>
      <li v-if="setAttr.length > 0">
        <span style="width:100%;margin-bottom:15px"><i style="color:#f00">*</i> 选择产品属性 </span>
        <div class="attr" v-for="(item,i) in setAttr">
          <h1>{{item.name}}</h1>
          <div class="right">
            <a :class="isInArray(vo.name) == true ? 'curt' : ''" v-for="(vo,k) in item.child" :data-id="vo.price">{{vo.name}}</a>
          </div>
        </div>
      </li>

      <li v-if="detail.share == 1 && setShare.length > 0">
        <span style="width:100%;margin-bottom:10px"><i style="color:#f00">*</i> 选择联票促销产品<em style="font-style:normal;font-size:12px;color:#666">（产品以0元显示，具体以协议结算为主）</em></span>
        <div style="clear:both;"></div>
        <div class="related">
          <div class="item" v-for="(item,i) in setShare" :data-id="i">
            <el-image style="width:60px;height:50px; border-radius:5px;" :src="baseUrl+item.img" fit="cover"></el-image>
            <div class="con">
              <div class="title">{{item.title}}</div>
              <div class="price">{{item.mallName}} 售价<em>￥{{item.rate}}</em></div>
            </div>
            <b :class="isInArray1(item.id) == true ? 'el-icon-success' : 'curt'"></b>
          </div>
        </div>
      </li>
      <li>
        <span style="width:100%;margin-bottom:10px"><i style="color:#f00">*</i> 产品介绍
          <a @click="getQquey13(2)"><em class="el-icon-picture-outline-round"></em>插入图片</a>
        </span>
        <div style="clear:both"></div>
        <quill-editor v-model="content" :options="editorOption" ref="content"></quill-editor>
        <!--<textarea placeholder="请输入产品介绍" v-model="content"></textarea>-->
      </li>
    </ul>
    <ul class="lsls">
      <li @click="getQquey13(1)">
        <span style="padding-bottom:15px"><i style="color:#f00">*</i> 产品介绍图<i style="font-size:12px;color:#666;font-style: normal">（请上传 640 × 480 格式图片）</i></span>
        <img class="icon" src="~assets/images/icon5.png" />
        <img v-for="(item,i) in img" class="imgs" :src="baseUrl+item" />
      </li>
    </ul>

    <button class="addAddress" @click="save123">立即发行</button>
    <div style="height:30px"></div>


    <el-drawer
      title="选择产品分类" :visible.sync="drawer" :direction="direction" size="55%" :withHeader="true">
      <ul>
        <li v-for="(item,i) in cate">
          <p><b @click="catec(i,item.id,item.title)">{{item.title}}</b><font @click="delcate(item.id)">删除</font></p>
          <a @click="catec(i,item.id,item.title)" v-if="i==active"><img src="~assets/images/choose2.png" /></a>
          <a @click="catec(i,item.id,item.title)" v-if="i!=active"><img src="~assets/images/choose1.png" /></a>
        </li>
        <li><button @click="addcate">添加分类</button></li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  import { quillEditor, Quill } from 'vue-quill-editor'
  const toolbarOptions = [
    [{'align': []}],
  ]
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        cate:[],
        detail:[],
        title:'',
        price:'',
        rate:'',
        jianj:'',
        content:'',
        img:[],
        direction: 'btt',
        drawer:false,
        active:-1,
        msg:'',
        cate_id:0,
        pro_id:'',
        setpro:[],
        setAttr:[],
        attr:[],
        relatedArr:[],
        editorOption: {
          placeholder: '请输入产品介绍',
          modules: {
            toolbar: {
              container: toolbarOptions, 
            }
          }
        }
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      var pro_id = this.$route.query.pro_id;
      this.pro_id = pro_id
      if(pro_id > 0){
        this.getpro();
      }
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    components: {
      'quill-editor': quillEditor
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.proCate();
      this.getAttr();
      this.getShare();
      $('body').on('click','.attr .right a',function(){
        if($(this).attr('class') == 'curt'){
          $(this).removeClass('curt');
        }else{
          $(this).addClass('curt');
        }
      })

      $('body').on('click','.related .item',function(){
        if($(this).find('b').attr('class') == 'curt'){
          $(this).find('b').removeClass('curt');
          $(this).find('b').addClass('el-icon-success');
        }else{
          $(this).find('b').removeClass('el-icon-success');
          $(this).find('b').addClass('curt');
        }
      })

    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      isInArray:function(value){ 
        var arr = this.attr
        if(arr.indexOf && typeof(arr.indexOf)=='function'){ 
          var index = arr.indexOf(value); 
          if(index >= 0){ 
            return true; 
          } 
        } 
        return false; 
      },
      isInArray1:function(value){ 
        var arr = this.relatedArr
        if(arr.indexOf && typeof(arr.indexOf)=='function'){ 
          var index = arr.indexOf(value); 
          if(index >= 0){ 
            return true; 
          } 
        } 
        return false; 
      },
      chooseCate:function(){
        this.drawer = true;
      },
      catec:function(i,id,title){
        this.active = i;
        this.cate_id = id;
        this.msg = title;
        this.drawer = false;
      },
      delcate:function(id){
        var that = this;
        that.fullscreenLoading = true;
        that.$confirm('此操作将删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.axios({
            method:'post',
            url:that.$host+'home/product/delCate',
            params:{
              id:id
            }
          }).then(function(response){
            that.proCate();
            that.fullscreenLoading = false
          }).catch(err=>{
            console.log('请求失败:'+err);
            that.fullscreenLoading = false
          });
        }).catch(() => {
          that.fullscreenLoading = false;
        });
      },
      addcate:function(){
        var that = this;
        var id = that.$route.query.id;
        that.fullscreenLoading = true;
        that.$prompt('请输入分类名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {

          that.fullscreenLoading = false;
          if(value == null){
            that.$alert('请输入分类名称', '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          
          that.axios({
            method:'post',
            url:that.$host+'home/product/addCate',
            params:{
              id:id,
              title:value
            }
          }).then(function(response){
            that.proCate();
            that.fullscreenLoading = false
          }).catch(err=>{
            console.log('请求失败:'+err);
            that.fullscreenLoading = false
          });
        }).catch(() => {
          that.fullscreenLoading = false;
        });
      },
      getDetail:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/getBusiness',
          params:{
            id:id
          }
        }).then(function(response){
          that.detail = response.data.data;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      proCate:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/proCate',
          params:{
            b_id:id
          }
        }).then(function(response){
          that.cate = response.data.data;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      getAttr:function(){
        var that = this;
        var id = this.$route.query.id;
        $.ajax({
          type:'post',
          url:that.$host+'home/product/findAttr',
          data:{
            id:id,
          },
          dataType:'json',
          success:function(data){
            that.setAttr = data.data.content;
          }
        })
      },
      getShare:function(){
        var that = this;
        var id = this.$route.query.id;
        $.ajax({
          type:'post',
          url:that.$host+'home/product/getBusinessShare',
          data:{
            mall_id:id,
          },
          dataType:'json',
          success:function(data){
            that.setShare = data.data;
          }
        })
      },

      getpro:function(){
        var that = this;
        var id = this.$route.query.pro_id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/productDetail',
          params:{
            id:id
          }
        }).then(function(response){
          var rs = response.data.data;
          that.title = rs.title;
          that.price = rs.price;
          that.rate = rs.rate;
          that.jianj = rs.jianj;
          that.content = rs.content;
          that.img = rs.img;
          that.msg = rs.ctitle;
          that.cate_id = rs.cate_id;
          if(rs.attr.length > 0){
            var attr = rs.attr;
            var arr = [];
            for(var i=0;i<attr.length;i++){
              var child = attr[i].child;
              for(var k=0;k<child.length;k++){
                arr.push(child[k].name)
              }
            }
            that.attr = arr;
          }

          if(rs.related.length > 0){
            var related = rs.related;
            var arrRelated = [];
            for(var i=0;i<related.length;i++){
              arrRelated.push(related[i].id)
            }
            that.relatedArr = arrRelated
          }
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      save123:function(){
        var that = this;
        var b_id = that.$route.query.id;
        var arr = [];
        $('.couponadd .attr').each(function(){
          var child = [];
          $($(this).find('.right a')).each(function(){
            if($(this).attr('class') == 'curt'){
              var str = $(this).text();
              var price = $(this).attr('data-id');
              child.push({name:str,price:price})
            }
          })
          if(child.length > 0){
            var str1 = $(this).find('h1').text();
            arr.push({name:str1,child:child})
          }
        })
        var related = [];
        $('.related .item').each(function(i){
          if($(this).find('b').attr('class') == 'el-icon-success'){
            related.push(that.setShare[i])
          }
        })
        if(that.title == ''){
          that.$alert('请填写产品名称','提示');
          return false;
        }
        if(that.price == ''){
          that.$alert('产品原价','提示');
          return false;
        }
        if(that.rate == ''){
          that.$alert('请输入优惠价','提示');
          return false;
        }
        if(that.jianj == ''){
          that.$alert('请输入产品简介','提示');
          return false;
        }
        if(that.content == ''){
          that.$alert('请输入产品介绍','提示');
          return false;
        }
        if(that.cate_id == ''){
          that.$alert('请选择所属分类','提示');
          return false;
        }
        if(that.img.length <= 0){
          that.$alert('请选择产品介绍图','提示');
          return false;
        }
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/product/addPro',
          params:{
            id:that.pro_id,
            title:that.title,
            price:that.price,
            rate:that.rate,
            jianj:that.jianj,
            content:that.content,
            cate_id:that.cate_id,
            img:JSON.stringify(that.img),
            b_id:b_id,
            attr:JSON.stringify(arr),
            related:(related.length == 0 ? '' : JSON.stringify(related)),
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data;
          if(res.status == 200){
            that.$router.go(-1)
          }else{
            alert(res.message);
          }
          
        }).catch(err=>{
          that.fullscreenLoading = false;
            console.log('请求失败:'+err);
        });
        return false;
      },

      getQquey13:function(inx){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'chooseImage',
              'getLocalImgData'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['chooseImage'],
              success: function (res) {
                wx.chooseImage({
                  count: 1,
                  sizeType: ['compressed'],
                  sourceType: ['album', 'camera'], 
                  success: function(res) {
                      that.fullscreenLoading = true;
                      var localId = res.localIds[0].toString();
                      wx.getLocalImgData({
                          localId: localId, // 图片的localID
                          success: function(res) {
                            var u = navigator.userAgent;
                            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                            var s = res.localData;
                            if(isAndroid){
                              s = 'data:image/jpg;base64,'+res.localData
                            }
                            that.getAjax(s,inx)
                          }
                      });
                  }
                })
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getAjax:function(localData,inx){
        var that = this;
        $.ajax({
          url:this.$host+'home/product/upload',
          method: 'post',
          data:{
            localData:localData
          },
          success:function(msg){
            if(msg.status == 200){
              if(inx == 1){
                that.img.push(msg.data);
              }else{
                var str = '<p><img src="'+that.baseUrl+msg.data+'"/></p>';
                that.content = that.content+str
              }
            }else{
              alert('上传失败');
            }
            that.fullscreenLoading = false;
          }
        })
      },

    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .couponadd{
    max-width:640px;
    background:#ebebeb;
    margin:0 auto;
  }
  .couponadd ul.lsls{
    display:block;
    width:100%;
    background:#fff;
    margin:0 auto;
    margin-bottom:50px;
    background: #FFFFFF;
  }
  .couponadd ul.first{
    margin-bottom:15px;
  }
  .couponadd ul.lsls li{
    width:94%;
    margin:0 auto;
    border-bottom:solid 1px #E7E7E7;
    padding:15px 0;
    position: relative;
  }
  .couponadd ul.lsls li font{
    position:absolute;
    right:0px;
    top:14px;
    font-size:14px;
    color:#333
  }
  .couponadd ul.lsls li .icon{
    position:absolute;
    right:0px;
    top:18px;
    width:7px
  }
  .couponadd ul.lsls li:last-child{
    border-bottom:none;
  }
  .couponadd ul li:first-child h2{
    font-size:18px
  }
  .couponadd li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .couponadd ul li span{
    display:block;
    width:100%;
    font-size:15px;
  }
  .couponadd ul.first li span{
    float:left;
    width:25%;
    color: #1C222B;
  }
  .couponadd ul.first li span a{
    float:right;
    font-size:12px;
    color:#0059D6;
  }
  .couponadd ul.first li span a em{
    font-weight:bold;
    padding-right:2px
  }
  .couponadd ul li input{
    display:block;
    width:100%;
    background:none;
    border:none;
    outline:none;
    font-size:15px;
    margin-top:1px;
  }
  .couponadd ul.first li input{
    float:right;
    width:60%;
    text-align:right;
    margin-right:5%
  }
  .couponadd ul li .imgs{
    width:31%;
    margin-right:2%
  }
  .couponadd ul li .checkbox{
    float:right;
    width:auto !important;
    margin-right:30px;
    margin-top:4px
  }
  .couponadd ul li textarea{
    width:calc(100% - 16px);
    background: #F1F2F5;
    border-radius: 5px;
    border:none;
    outline:none;
    font-size:15px;
    resize: none;
    min-height:120px;
    padding:8px
  }
  .couponadd .addAddress{
    display:block;
    margin:0 auto;
    width:80%;
    height:45px;
    border:none;
    background:#2F78FF;
    color:#fff;
    font-size:16px;
    border-radius:45px;
  }


  .couponadd ul li .attr:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  }
  
  .couponadd ul li .attr h1{
    float:left;
    width:50px;
    font-size:15px;
    font-weight:bold;
    margin-top:5px;
    text-align:center
  }
  .couponadd ul li .attr .right{
    float:left;
    width:calc(100% - 50px);
  }
  .couponadd ul li .attr .right a{
    width:85px;
    height:30px;
    background: #F1F2F5;
    font-size:13px;
    float:left;
    border-radius:5px;
    line-height:30px;
    text-align:center;
    margin-right:15px;
    margin-bottom:15px;
    color: #1C222B;
  }
  .couponadd ul li .attr .right a.curt{
    color:#0059D6;
    font-weight:bold;
    background: rgba(0,89,214,0.1);
  }
  .couponadd ul li .related{
    background:#F1F2F5;
    padding: 12px 0;
    border-radius:6px;
  }
  .couponadd ul li .related .item:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .couponadd ul li .related .item{
    position:relative;
    height:50px;
    clear:both;
    margin-bottom:15px;
  }
  .couponadd ul li .related .item:last-child{
    margin-bottom:0
  }
  .couponadd ul li .related .item .el-image{
    float:left;
    margin-left:40px
  }
  .couponadd ul li .related .item .con{
    float:left;
    height:50px;
    width:calc(100% - 108px);
    margin-left:8px;
    position:relative;
  }
  .couponadd ul li .related .item .con .title{
    font-size:15px;
  }
  .couponadd ul li .related .item .con .price{
    font-size:12px;
    color:#666;
    position:absolute;
    bottom:0px;
    width:100%
  }
  .couponadd ul li .related .item .con .price em{
    color:#f00;
    font-style:normal;
  }
  .couponadd ul li .related .item b{
    position:absolute;
    left:10px;
    font-size:22px;
    top:50%;
    transform: translateY(-50%);
  }
  .couponadd ul li .related .item b.curt{
    border:solid 1px #666;
    width:17px;
    height:17px;
    border-radius:50%;
  }

  .couponadd .el-drawer{
    overflow-y: scroll;
  }
  .couponadd .el-drawer .el-drawer__header{
    margin-bottom:0;
    position: fixed;
    width:90%;
    background:#fff !important;
    z-index:999;
    padding:10px 20px
  }
  .couponadd .el-drawer__wrapper ul{
    width:90%;
    margin:20px auto;
    padding-top:20px
  }
  .couponadd .el-drawer__wrapper li{
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0 10px 0;
    position:relative;
  }
  .couponadd .el-drawer__wrapper li:last-child{
    border-bottom:none;
  }

  .couponadd .el-drawer__wrapper li p{
    padding-bottom:7px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-left:45px;
  }

  .couponadd .el-drawer__wrapper li button{
    background:#2F78FF;
    color:#fff;
    font-size:16px;
    border-radius:45px;
    display:block;
    border:none;
    margin:0 auto;
    width:80%;
    padding:10px 0;
    margin-top:20px
  }
  .couponadd .el-drawer__wrapper li p font{
    float:right;
    font-size:14px;
    color:#f00
  }
  .couponadd .el-drawer__wrapper li p:last-child{
    color: #666;
  }

  .couponadd .el-drawer__wrapper li a{
    position:absolute;
    left:0;
    top:50%;
    transform: translateY(-50%);
    color: #2F78FF;
    font-size:18px;
  }
  .couponadd .el-drawer__wrapper li a img{
    display:block;
    width:30px;
  }
  .couponadd .quill-editor{
    background: #F1F2F5;
    border-radius: 5px;
    font-size:15px;
    min-height:220px;
  }
  .couponadd .quill-editor .ql-toolbar{
    display:none;
  }
  .couponadd .quill-editor .ql-snow{
    border:none !important;
  }
  .couponadd .quill-editor .ql-editor{
    min-height:300px;
  }
</style>